globalThis.backoffice = globalThis.backoffice || {};

backoffice.ModalCommunicationCenter = (function(superClass)
{
  utils.extend(ModalCommunicationCenter, superClass);

  function ModalCommunicationCenter($html) {
    return ModalCommunicationCenter.__super__.constructor.apply(this, arguments);
  }

  $.extend(ModalCommunicationCenter.prototype, {
    init: function() {
      var self = this;
      backoffice.initSelect2(this.$html.find('.select'));
      backoffice.initSelect2Search(this.$html.find('.select-search'));
      autosize(this.$html.find('.elastic'));
      this.$html.find('.styled').uniform({radioClass: 'choice'});

      this.$html.find('.submit-on-change').on('change', function () {
        if (!$(this).hasClass('no-loader')) {
          backoffice.loader.start();
        }
        $(this).closest('form').submit();
      });

      this.$html.find('.form-submit-ajax').each(function () {
        new backoffice.formSubmitAjax($(this));
      });

      new backoffice.CallCenter(self.$html, {
        loader: self,
        selectors: {
          successOverlay: '.modal-overlay-success',
          errorOverlay: 'modal-overlay-error'
        }
      })

      new backoffice.TwilioServices(self.$html, {
        loader: self,
        selectors: {
          successOverlay: '.modal-overlay-success',
          errorOverlay: 'modal-overlay-error'
        }
      })

      ModalCommunicationCenter.__super__.init.apply(this, arguments);
    },
    callbackSuccess: function(data) {
      ModalCommunicationCenter.__super__.callbackSuccess.apply(this, arguments);
    },
  });

  return ModalCommunicationCenter;
})(backoffice.ModalMain);
